import { useState } from "react";
import { toast } from "sonner";
import { Sparkles, Loader2, Copy } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { Select } from "@/components/shop/common";

const KINDS = [
  { value: "estimate", label: "Estimate approval" },
  { value: "update", label: "Progress update" },
  { value: "ready", label: "Ready for pickup" },
  { value: "invoice", label: "Invoice / thank you" },
];

export default function MessageDialog({ open, onOpenChange, wo }) {
  const [kind, setKind] = useState("estimate");
  const [channel, setChannel] = useState("text");
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  const gen = async () => {
    setBusy(true);
    try { const { data } = await api.post("/ai/customer-message", { work_order_id: wo.id, kind, channel }); setMsg(data.message); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-card border-border rounded-sm max-w-xl" data-testid="message-dialog">
        <DialogHeader><DialogTitle className="font-display text-3xl uppercase">Customer message</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <Select value={kind} onChange={(e) => setKind(e.target.value)} options={KINDS} data-testid="message-kind-select" />
          <Select value={channel} onChange={(e) => setChannel(e.target.value)} options={[{ value: "text", label: "Text message" }, { value: "email", label: "Email" }]} data-testid="message-channel-select" />
        </div>
        <Button onClick={gen} disabled={busy} className="rounded-sm hover:bg-orange-600 hover:text-white" data-testid="message-generate-btn">
          {busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Sparkles className="h-4 w-4 mr-2" />} {busy ? "Writing..." : "Write with AI"}
        </Button>
        {msg && (
          <>
            <textarea rows={8} value={msg} onChange={(e) => setMsg(e.target.value)} className="w-full p-3 rounded-sm bg-[#0B0F17] border border-input text-sm" data-testid="message-output" />
            <Button variant="outline" className="rounded-sm hover:text-white" data-testid="message-copy-btn"
              onClick={() => { navigator.clipboard?.writeText(msg); toast.success("Message copied — paste it into your text or email app"); }}>
              <Copy className="h-4 w-4 mr-2" /> Copy message
            </Button>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
